"use strict";

angular.module("vendor")
.controller("ReportController", function(
    $rootScope, $scope, $window, $stateParams, $document, $cookies, $location, $interval, $q, gettextCatalog, Language,
    appConfig, StateExtensionService, ReportService, ModalService, UserService
) {
    var _this = this;
    var currentDashboardId, sessionValidationPromise;

    const SESSION_VALIDATION_INTERVAL_MILLISECONDS = 30000; // 30 seconds
    const REDIRECT_URL = appConfig.VENDOR_URL + "/reports";
    const AWS_COGNITO_DOMAIN_URL = appConfig.AWS_COGNITO_DOMAIN_URL;
    const AWS_COGNITO_CLIENT_ID = appConfig.AWS_COGNITO_CLIENT_ID;
    const LOCALE_MAPPING = {
        "en_US": "en-US",
        "fr_CA": "fr-FR",
        "es_ES": "es-ES"
    };

    $scope.openIdToken = getParameterValues('id_token', '#', '&');
    if (!$scope.openIdToken) {
        $scope.openIdToken = $cookies.get('qs_open_id_token');
    }

    function setOpenIdTokenCookie(openIdToken) {
        var expirySeconds = getParameterValues('expires_in', '#', '&');
        if (expirySeconds) {
            var expirationDate = new Date();
            expirationDate.setTime(expirationDate.getTime() + (parseInt(expirySeconds) * 1000));
            $cookies.put('qs_open_id_token', openIdToken, {'expires': expirationDate});
            $cookies.put('qs_expiration_date', expirationDate.toISOString());
            $location.hash('');
        }
    }

    this.getDashboards = function() {
        validateSession().then(function() {
            ReportService.getDashboards($scope.openIdToken).$promise.then(function onSuccess(data) {
                $scope.dashboards = data['dashboards'];
                if ($scope.dashboards.length >= 1) {
                    $scope.selectedDashboard = $scope.dashboards[0].id;
                    _this.embedDashboard($scope.selectedDashboard);
                }
            });
        });
    };

    function refreshEmbedDashboard(dashboardId) {
        _this.embedDashboard(dashboardId, true);
    }

    this.embedDashboard = function(dashboardId, forceRefresh) {
        if (!dashboardId || (dashboardId && !forceRefresh && currentDashboardId === dashboardId)) {
            return;
        }

        validateSession().then(function() {
            var embedContainer = document.getElementById('experience-container');

            ReportService.getEmbedUrl($scope.openIdToken, dashboardId).$promise.then(function onSuccess(data) {
                embedContainer.innerHTML = '';
                QuickSightEmbedding.createEmbeddingContext().then(function onSuccess(embeddingContext) {
                    var frameOptions = {
                        url: data['embed_url'],
                        container: embedContainer,
                        withIframePlaceholder: true,
                        resizeHeightOnSizeChangedEvent: true,
                    };
                    var contentOptions = {
                        locale: getLocale(),
                        sheetOptions: {
                            singleSheet: true,
                            emitSizeChangedEventOnSheetChange: true,
                        },
                        toolbarOptions: {
                            export: true,
                            undoRedo: true,
                            reset: true
                        },
                        attributionOptions: {
                            overlayContent: false,
                        },
                    };
                    embeddingContext.embedDashboard(frameOptions, contentOptions);
                    currentDashboardId = dashboardId;
                });
            });
        });
    }

    this.login = function() {
        $window.location.href = AWS_COGNITO_DOMAIN_URL + '/login?client_id=' + AWS_COGNITO_CLIENT_ID + '&response_type=token&scope=openid+profile&redirect_uri=' + REDIRECT_URL;
    };

    this.logoutConfirmation = function() {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Report logout"),
                    message: gettextCatalog.getString("Do you want to logout?", null, "Report logout message")
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                if (result) {
                    logout();
                }
            });
        });
    }

    function logout() {
        $cookies.remove('qs_open_id_token');
        $cookies.remove('qs_expiration_date');
        cancelSessionValidationInterval();
        $window.location.href = AWS_COGNITO_DOMAIN_URL + '/logout?client_id=' + AWS_COGNITO_CLIENT_ID + '&redirect_uri=&response_type=&logout_uri=' + REDIRECT_URL;
    }

    function validateSession() {
        var deferred = $q.defer();

        if ($scope.openIdToken && $cookies.get('qs_open_id_token') && $cookies.get('qs_expiration_date')) {
            var currentDate = new Date().getTime();
            var expirationDate = Date.parse($cookies.get('qs_expiration_date'));

            if (expirationDate <= currentDate) {
                stopSession(deferred);
            }
            else {
                deferred.resolve();
            }
        }
        else {
            deferred.reject();
        }
        return deferred.promise;
    }

    function stopSession(deferred) {
        $cookies.remove('qs_open_id_token');
        $cookies.remove('qs_expiration_date');
        cancelSessionValidationInterval();

        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Report session expired"),
                    message: gettextCatalog.getString(
                        "Your session has expired. You must login again to continue using the reports. Do you want to login?",
                        null,
                        "Report session expired message"
                    )
                }
            }
        }).then(function(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(result) {
                deferred.reject();
                if (result) {
                    _this.login();
                }
                else {
                    logout();
                }
            });
        });
    }

    function cancelSessionValidationInterval() {
        if (angular.isDefined(sessionValidationPromise)) {
            $interval.cancel(sessionValidationPromise);
            sessionValidationPromise = undefined;
        }
    }

    function getParameterValues(param, slicer, delimiter) {
        var urlParams = $window.location.href.slice($window.location.href.indexOf(slicer) + slicer.length).split(delimiter);
        for (var i = 0; i < urlParams.length; i++) {
            var urlParam = urlParams[i].split('=');
            if (urlParam[0].toLowerCase() === param) {
                return decodeURIComponent(urlParam[1]);
            }
        }
    }

    function getLocale() {
        if (_this.locale in LOCALE_MAPPING) {
            return LOCALE_MAPPING[_this.locale];
        }
        return LOCALE_MAPPING[0];
    }

    function init() {
        if ($scope.openIdToken) {
            setOpenIdTokenCookie($scope.openIdToken);
            sessionValidationPromise = $interval(validateSession, SESSION_VALIDATION_INTERVAL_MILLISECONDS);
            _this.getDashboards();
        }

        UserService.isUserFetched().then(function onSuccess(user) {
            Language.initializeController(_this, null, "locale");
        });
    }

    $document.ready(function() {
        init();
    });

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, newLocale) {
        if (_this.locale && _this.locale !== newLocale && $scope.openIdToken && $scope.selectedDashboard) {
            refreshEmbedDashboard($scope.selectedDashboard);
        }
    });

    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
        cancelSessionValidationInterval();
    });
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/report/report.controller.js
// module id = 1020
// module chunks = 0